
class CareerImages {
  constructor() {
    this.parent = document.querySelector(".career-values");
    this.lastScroll;
    if (document.querySelector(".career-values")) {
      this.scrollAnimation();
      this.observe();
    }
  }

  scrollAnimation() {
    let elements = document.querySelectorAll('.career-values__image-container[data-speed="0.5"]');
    elements.forEach((el) => {
        el.style.transform = 'translateY(50%)'
        gsap.to(el, {
          ease:'none',
          y: -50,
          scrollTrigger: {
            trigger: el.parentElement,
            scrub: 0.5,
            y: 50,
          }
        })
    });
    let text_elements = document.querySelectorAll('.career-values__value--text');
    text_elements.forEach((el) => {
        gsap.to(el, {
          ease:'none',
          y: -50,
          scrollTrigger: {
            trigger: el.parentElement,
            scrub: 0.5,
            y: 50,
          }
        })
    });
  }


  observe() {
    const parent = document.querySelector('.career-values')
    let imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('career-values__image--animate')
        }
      })
    })

    const images = parent.querySelectorAll('.career-values__image')
    images.forEach(image => {
      imageObserver.observe(image)
    })
  }
}

export default CareerImages;
